"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sirenSvg = _interopRequireDefault(require("../siren-svg"));
var _excluded = ["ariaLabel", "children", "name", "size", "tagName"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * A tag containing the Siren icon intended to be used as the
 * logo and link to home in a website. Accepts children to support
 * custom applications, such as including a site title.
 */
var Logo = function Logo(_ref) {
  var ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '50px' : _ref$size,
    _ref$tagName = _ref.tagName,
    TagName = _ref$tagName === void 0 ? 'a' : _ref$tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var getAriaLabel = function getAriaLabel() {
    // support the older "name" prop if the consumer is using it
    if (name) {
      // eslint-disable-next-line no-console
      console.warn('The "name" prop on the Logo component is deprecated. Please pass the accessible name as the ariaLabel prop instead.');
      return name;
    }
    // If they are using the ariaLabel prop, use it. If not, they can also
    // pass `aria-label` which will be spread onto the element
    // via `otherProps`, so it's ok for this function to return undefined.
    return ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : undefined;
  };
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    "aria-label": getAriaLabel()
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_sirenSvg["default"], {
    size: size
  }), children);
};
Logo.displayName = 'Logo';
Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Provides an accessible label for the logo. Typically this will say "Home"
   * so that the screenreader will announce "Home, link".
   */
  ariaLabel: _propTypes["default"].string,
  /**
   * Optional children can be used to customize the implementation.
   */
  children: _propTypes["default"].any,
  /**
   * Provides an accessible label for the logo.
   * Deprecated, please use `ariaLabel` or `aria-label` instead.
   */
  name: _propTypes["default"].string,
  /**
   * Tag to use as the outermost html element. Default to <a>.
   */
  tagName: _propTypes["default"].any,
  /**
   * Size including unit
   */
  size: _propTypes["default"].string
} : {};
var _default = exports["default"] = Logo;